'use client'

import axiosProvider from '@/lib/AxiosProvider'
import { _emailRegex_ } from '@/lib/Regex'
import { _exception } from '@/lib/exceptionMessage'
import { _projectName_ } from '@/utils/helper/AllStaticVariables/configVariables'
import { ErrorMessage, Form, Formik } from 'formik'
import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import { currencyIcon, showToast, spaceToDash } from '../../lib/GetBaseUrl'
import Loader from '../Loader'
import TextError from '../base/TextError'

const Footer = ({ staticData }) => {
  const [loading, setLoading] = useState(false)
  const pathName = usePathname()
  const dispatch = useDispatch()
  const [path, setPath] = useState(pathName)
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(_emailRegex_, 'Please enter valid email')
      .required('Email Address is required')
  })

  const onSubmit = async (values, { resetForm }) => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'POST',
        endpoint: 'Subscribe',
        data: values
      })
      setLoading(false)
      if (response?.status === 200) {
        showToast(dispatch, response)
        resetForm({ values: '' })
      }
    } catch (error) {
      showToast(dispatch, {
        data: { code: 204, message: _exception?.message }
      })
    }
  }

  useEffect(() => {
    setPath(pathName)
  }, [pathName])

  return (
    path !== '/explore' && (
      <footer className="footer">
        {loading && <Loader />}
        {/* <div className="footer_contact_details">
          <div className="footer_contact_wrapper site-container">
            <div className="footer_contact_col">
              <div className="footer_contact_special_dec_wrapper">
                <i className="m-icon footer_mail-icon"></i>
                <p className="footer_contact_dec">
                  Get special discount on your inbox
                </p>
              </div>
              <div className="footer_mail_ip_wrapper">
                <Formik
                  enableReinitialize={true}
                  initialValues={{ email: "" }}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {({ values, setFieldValue }) => (
                    <Form>
                      <input
                        type="text"
                        name="email"
                        onBlur={(e) => {
                          let fieldName = e?.target?.name;
                          setFieldValue(fieldName, values[fieldName]?.trim());
                        }}
                        value={values?.email}
                        onChange={(e) => {
                          const fieldName = e?.target?.name;
                          setFieldValue(fieldName, e?.target?.value);
                        }}
                        placeholder="Enter your mail..."
                        className="footer_mail_ip"
                      />
                      <button className="footer_mail_label" type="submit">
                        <i className="m-icon footer_mail_ip_icon"></i>
                      </button>
                      <div className="footer_sub_error">
                        <ErrorMessage name="email" component={TextError} />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <div className="footer_contact_col">
              <div className="footer_contact_mobile_wrapper">
                <i className="m-icon footer_mobile-icon"></i>
                <p className="footer_contact_dec">
                  EXPERIENCE THE {_projectName_?.toUpperCase()} MOBILE APP
                </p>
              </div>
              <div className="footer_mobile_app_wrapper">
                <Link href="#." className="footer_mobile_app_link">
                  <Image
                    src="/images/play-store.png"
                    width="130"
                    height="130"
                    sizes="100vw"
                    className="footer_mobile_img"
                    alt={`Get the ${_projectName_} app on Google Play`}
                  />
                </Link>
                <Link href="#." className="footer_mobile_app_link">
                  <Image
                    src="/images/app-store.png"
                    width="130"
                    height="130"
                    sizes="100vw"
                    className="footer_mobile_img"
                    alt={`Download the ${_projectName_} app on the App Store`}
                  />
                </Link>
              </div>
            </div>
            <div className="footer_contact_col">
              <div className="footer_contact_help-wrapper">
                <i className="m-icon footer_help-icon"></i>
                <p className="footer_contact_dec">
                  FOR ANY HELP, YOU MAY CALL US AT 1600-207-3333
                </p>
              </div>
              <p className="footer_contact_dec">
                (Monday to Saturday, 8AM to 10PM and Sunday, 10AM to 7PM)
              </p>
            </div>
          </div>
        </div>
        <div className="footer_middle_details">
          <div className="site-container">
            <Image
              className="footer_site_logo"
              src="/images/FooterLogo.svg"
              alt="footer_site_logo"
              width={100}
              height={100}
            />
            <div className="footer_menu_wrapper">
              <ul className="footer_menu_item">
                <li className="footer_menu_list">
                  <h3 className="footer_menu_heading">Who are we?</h3>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Careers
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="/proof" className="footer_menu_link">
                    Proof &amp; Lab Reports
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Press
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Testimonials
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Responsible Disclosure
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Investor Relations
                  </Link>
                </li>
              </ul>
              <ul className="footer_menu_item">
                <li className="footer_menu_list">
                  <h3 className="footer_menu_heading">Help</h3>
                </li>
                <li className="footer_menu_list">
                  <Link href="/contact-us" className="footer_menu_link">
                    Contact Us
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Frequently asked questions
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Store Locator
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Cancellation & Return
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Shipping & Delivery
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Sell on Nykaa
                  </Link>
                </li>
              </ul>
              <ul className="footer_menu_item">
                <li className="footer_menu_list">
                  <h3 className="footer_menu_heading">Inspire Me</h3>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Beauty Book
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Buying Guides
                  </Link>
                </li>
              </ul>
              <ul className="footer_menu_item">
                <li className="footer_menu_list">
                  <h3 className="footer_menu_heading">Quick Links</h3>
                </li>
                {staticData?.data?.length > 0 && (
                  <div>
                    {staticData?.data?.map((item, index) => (
                      <li className="footer_menu_list" key={index}>
                        <Link
                          href={`/${spaceToDash(item?.name?.toLowerCase())}`}
                          className="footer_menu_link"
                          target="_blank"
                        >
                          {item?.name}
                        </Link>
                      </li>
                    ))}
                  </div>
                )}
              </ul>
              <ul className="footer_menu_item">
                <li className="footer_menu_list">
                  <h3 className="footer_menu_heading">Top Categories</h3>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Makeup
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Skin
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Hair
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Bath & Body
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Appliances
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Mom and Baby
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Wellness
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Luxe
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link href="#" className="footer_menu_link">
                    Natural
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer_shipping_details">
          <div className="site-container">
            <div className="footer_shipping_wrapper">
              <div className="footer_shipping_col">
                <div className="footer_shipping_details_wrapper">
                  <span className="footer_shipping_span">
                    <i className="m-icon free_shipping-icon"></i>
                  </span>
                  <div className="footer_shipping_item">
                    <p className="footer_shipping_name">FREE SHIPPING</p>
                    <p className="footer_shipping_order-details">
                      On Orders Above
                      {currencyIcon}299
                    </p>
                  </div>
                </div>
              </div>
              <div className="footer_shipping_col">
                <div className="footer_shipping_details_wrapper">
                  <span className="footer_shipping_span">
                    <i className="m-icon return-icon"></i>
                  </span>
                  <div className="footer_shipping_item">
                    <p className="footer_shipping_name">EASY RETURNS</p>
                    <p className="footer_shipping_order-details">
                      15-Day Return Policy
                    </p>
                  </div>
                </div>
              </div>
              <div className="footer_shipping_col">
                <div className="footer_shipping_details_wrapper">
                  <span className="footer_shipping_span">
                    <i className="m-icon authentic-icon"></i>
                  </span>
                  <div className="footer_shipping_item">
                    <p className="footer_shipping_name">100% AUTHENTIC</p>
                    <p className="footer_shipping_order-details">
                      Products Sourced Directly
                    </p>
                  </div>
                </div>
              </div>
              <div className="footer_shipping_col">
                <div className="footer_shipping_details_wrapper">
                  <span className="footer_shipping_span">
                    <i className="m-icon brand-icon"></i>
                  </span>
                  <div className="footer_shipping_item">
                    <p className="footer_shipping_name">1900+ BRANDS</p>
                    <p className="footer_shipping_order-details">
                      1.2 Lakh+ Products
                    </p>
                  </div>
                </div>
              </div>
              <div className="footer_shipping_col">
                <div className="footer_shipping_details_wrapper">
                  <div className="footer_shipping_social">
                    <p className="footer_shipping_order-details">
                      Show us some love ❤ on social media
                    </p>
                    <Link href="#." className="footer_social_link">
                      <Image
                        src="/images/instagram.png"
                        alt="image"
                        width="30"
                        height="30"
                        sizes="100vw"
                        className="footer_social_icon"
                      />
                    </Link>
                    <Link href="#." className="footer_social_link">
                      <Image
                        src="/images/Vector.png"
                        alt="image"
                        width="30"
                        height="30"
                        sizes="100vw"
                        className="footer_social_icon"
                      />
                    </Link>
                    <Link href="#." className="footer_social_link">
                      <Image
                        src="/images/facebook.png"
                        width="30"
                        height="30"
                        sizes="100vw"
                        className="footer_social_icon"
                        alt="image"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="footer_middle_details bg-[#FFF8EB] pt-9">
          <div className="site-container">
            <div className="grid max-md:grid-cols-2 grid-cols-5 gap-4 md:gap-8 items-start">
              {/* <Link href="/" className='sm:col-span-2 sm:mx-auto'>
                <Image
                  className="inline-block max-w-20 sm:max-w-32 w-full"
                  src="/images/NewLogo.svg"
                  alt="GoodSugar"
                  width={1000}
                  height={1000}
                  quality={100}
                />
              </Link> */}
              {/* <Link href="/" className="max-md:col-span-2 col-span-1 mx-auto">
                <Image
                  className="inline-block max-w-20 sm:max-w-32 w-full"
                  src="/images/NewLogo.svg"
                  alt="GoodSugar"
                  width={1000}
                  height={1000}
                  quality={100}
                />
              </Link> */}
              <div className="max-md:col-span-2 col-span-1 flex flex-col items-center gap-3">
                <Link href="/">
                  <Image
                    className="inline-block max-w-20 sm:max-w-32 w-full"
                    src="/images/NewLogo.svg"
                    alt="GoodSugar"
                    width={1000}
                    height={1000}
                    quality={100}
                  />
                </Link>

                <div className="footer_shipping_col">
                  <div className="footer_shipping_details_wrapper">
                    <div className="footer_shipping_social flex items-center justify-center gap-3">
                      <Link
                        href="https://www.instagram.com/goodsugar.in/"
                        className="footer_social_link"
                      >
                        <Image
                          src="/images/instagram.png"
                          alt="image"
                          width="30"
                          height="30"
                          sizes="100vw"
                          className="footer_social_icon w-[20px]! object-contain"
                        />
                      </Link>
                      <Link
                        href="https://www.facebook.com/profile.php?id=61587283179722"
                        className="footer_social_link"
                      >
                        <Image
                          src="/images/facebook.png"
                          width="20"
                          height="20"
                          sizes="100vw"
                          className="footer_social_icon w-[20px]! h-[20px]! object-contain"
                          alt="image"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <ul className="footer_menu_item space-y-2 max-sm:order-3">
                <li className="footer_menu_list">
                  <h3 className="footer_menu_heading">Resource</h3>
                </li>
                <li className="footer_menu_list">
                  <Link
                    href="/"
                    className="footer_menu_link group gap-2 items-center break-all"
                  >
                    Home
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link
                    href="/products/natural-sweetener?CategoryId=2"
                    className="footer_menu_link group gap-2 items-center break-all"
                  >
                    Products
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link
                    href="/about-us"
                    className="footer_menu_link group gap-2 items-center break-all"
                  >
                    About us
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link
                    href="/blogs"
                    className="footer_menu_link group gap-2 items-center break-all"
                  >
                    Blogs
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link
                    href="/contact-us"
                    className="footer_menu_link group gap-2 items-center break-all"
                  >
                    Contact us
                  </Link>
                </li>
              </ul>

              <ul className="footer_menu_item space-y-2 max-sm:order-2">
                <li className="footer_menu_list">
                  <h3 className="footer_menu_heading">Legal</h3>
                </li>
                {staticData?.data?.length > 0 && (
                  <>
                    {staticData?.data?.map((item, index) => (
                      <li className="footer_menu_list" key={index}>
                        <Link
                          href={`/${item?.name?.toLowerCase()?.replaceAll(' ', '-')}`}
                          className="footer_menu_link"
                          target="_blank"
                        >
                          {item?.name}
                        </Link>
                      </li>
                    ))}
                  </>
                )}
              </ul>

              <ul className="footer_menu_item space-y-2 max-sm:order-3">
                <li className="footer_menu_list">
                  <h3 className="footer_menu_heading">Contact Us</h3>
                </li>
                <li className="footer_menu_list">
                  {/* <Link href="/contact-us" className="footer_menu_link">
                      Contact Us
                    </Link> */}
                  <Link
                    href="tel:+91-9638949513"
                    className="footer_menu_link group gap-2 items-center break-all"
                  >
                    <i className="m-icon phone_icon w-[18px] h-[18px]"></i>
                    +91-9638949513
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link
                    href="tel:+91-82386 38550"
                    className="footer_menu_link group gap-2 items-center break-all"
                  >
                    <i className="m-icon phone_icon w-[18px] h-[18px]"></i>
                    +91-82386 38550
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link
                    href="mailto:hello@goodsugar.in"
                    className="footer_menu_link group gap-2 items-center break-all"
                  >
                    {/* <i className="m-icon email_icon bg-WhiteShade w-5 h-[0.875rem] flex-shrink-0"></i> */}
                    <i className="m-icon footer_mail-icon w-[18px] h-[18px]"></i>
                    hello@goodsugar.in
                  </Link>
                </li>
                <li className="footer_menu_list">
                  <Link
                    href="mailto:founder@goodsugar.in"
                    className="footer_menu_link group gap-2 items-center break-all"
                  >
                    {/* <i className="m-icon email_icon bg-WhiteShade w-5 h-[0.875rem] flex-shrink-0"></i> */}
                    <i className="m-icon footer_mail-icon w-[18px] h-[18px]"></i>
                    founder@goodsugar.in
                  </Link>
                </li>
              </ul>

              <ul className="footer_menu_item space-y-2 max-sm:order-3 ">
                <li className="footer_menu_list">
                  <h3 className="footer_menu_heading">Site</h3>
                </li>
                <li className="footer_menu_list">
                  <button
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: 'smooth' })
                    }
                    className="footer_menu_link group gap-2 items-center break-all"
                  >
                    Back To Top
                  </button>
                </li>
              </ul>
            </div>

            <div className="footer_contact_col max-w-[470px] mt-6">
              <div className="footer_contact_special_dec_wrapper inline-flex gap-2 mb-4">
                <p className="footer_contact_dec text-black! text-base">
                  Stay Up to date
                </p>
              </div>
              <div className="footer_mail_ip_wrapper">
                <Formik
                  enableReinitialize={true}
                  initialValues={{ email: '' }}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {({ values, setFieldValue }) => (
                    <Form>
                      <div className="flex rounded-lg items-center border border-primary bg-[#FFFBF2] overflow-hidden">
                        <input
                          type="text"
                          name="email"
                          onBlur={(e) => {
                            let fieldName = e?.target?.name
                            setFieldValue(fieldName, values[fieldName]?.trim())
                          }}
                          value={values?.email}
                          onChange={(e) => {
                            const fieldName = e?.target?.name
                            setFieldValue(fieldName, e?.target?.value)
                          }}
                          placeholder="Enter your email - Id"
                          className="flex-1 bg-white px-5 py-2.5 text-sm text-black placeholder:text-gray-500 outline-none min-w-0"
                        />
                        <button
                          type="submit"
                          className="bg-primary text-white text-sm font-semibold px-6 py-2.5 whitespace-nowrap hover:bg-[#a50811] transition-colors"
                        >
                          Subscribe Now
                        </button>
                      </div>
                      <div className="footer_sub_error">
                        <ErrorMessage name="email" component={TextError} />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>

            <div className="flex gap-2 flex-wrap justify-center items-center border-b border-[#CECECE] pt-6 pb-[1rem] lg:pb-[1rem] md:py-6 mt-6">
              <p className="text-primary  text-sm text-center">
                © {new Date().getFullYear()} Good Sugar Co. All rights reserved.
              </p>

              {/* <p className="text-primary text-sm">
                Powered by{' '}
                <Link
                  className="font-medium"
                  target="_blank"
                  href="https://www.buildecommerce.app/"
                >
                  BuildEcommerce
                </Link>
              </p> */}
            </div>
            <div className="flex gap-2 flex-wrap justify-center md:justify-center items-centerpt-6 md:pt-6">
              <p className="text-[8vw] text-primary">Good Sugar Co.</p>
            </div>
          </div>
        </div>
      </footer>
    )
  )
}

export default Footer
